import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Label } from "../ui/label";

export interface Item {
  value: string;
  label: string;
}
interface Props {
  isReadOnly?: boolean;
  items: Item[];
  setSelectedString: React.Dispatch<React.SetStateAction<string>>;
  selectedString: string;
  label: string;
  placeholder?: string;
}
function Dropdown({
  label,
  items,
  setSelectedString,
  selectedString,
  isReadOnly,
  placeholder,
}: Props) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <Label>{label}</Label>
      <Select
        disabled={isReadOnly ?? false}
        onValueChange={(value) => {
          setSelectedString(value);
        }}
        value={selectedString}
      >
        <SelectTrigger disabled={isReadOnly ?? false} className={isReadOnly ? "pointer-events-none opacity-50" : ""}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {items.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>

      </Select>
    </div>
  );
}

export default Dropdown;
